import React from "react";
import ReactDOM from "react-dom";
import AppContainer from "./AppContainer";
import "bootstrap/dist/css/bootstrap.min.css";

import "@aws-amplify/ui-react/styles.css"; // default theme

ReactDOM.render(<AppContainer />, document.getElementById("root"));
